import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { $crud } from "../helper/CrudFactory";
import { BranchPosition } from "../Languages/vars/BranchPosition";
import { LoadingDots } from "../LoadingDots/LoadingDots";
import LanguageContext from "../helper/LanguageContext";
import { isLanguageSupported, translate } from "../Languages/index";
import RegisterCaptcha from "../components/RegisterCaptcha";
import { isGermanFamily } from "./auth/authLanguages";
import { AuthEye, AuthFrame, AuthHead, AuthInput, AuthNotice, AuthSpacer, AuthTitle } from "./auth/AuthPro";
import { PASSWORD_MIN_LENGTH, PLUS_PASSWORD_MIN_LENGTH, meetsPasswordRule } from "./auth/passwordRule";

function Register(props) {
  const { strings, setLanguage: setContextLanguage } = React.useContext(LanguageContext);
  
  // Initialize local language state from localStorage
  const [language, setLanguage] = React.useState(() => {
    const stored = localStorage.getItem("language");
    // Check if stored language is supported (all 22 languages)
    if (stored && isLanguageSupported(stored)) {
      return stored.toUpperCase();
    }
    return localStorage.getItem("switch") === "2" ? "DE" : "EN";
  });
  const [isGerms, setIsGerm] = useState(() => {
    const stored = localStorage.getItem("language");
    if (stored) return stored === 'de';
    return localStorage.getItem("switch") === "2";
  });
  const t = (key) => translate(key, language.toLowerCase());
  // /register-kjuup-io: same form, and the backend starts the Kjuup.io free trial with the account.
  const kjuupIo = !!props.kjuupIo;
  const [token, setToken] = useState("")
  const [isKjuupPlus, setIsKjuupPlus] = useState(false)
  const [branchData, setBranchData] = useState(null)
  const [showPIN, setShowPIN] = useState(false)
  const [captchaEnabled, setCaptchaEnabled] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  // const location = useLocation();
  // const query = new URLSearchParams(location.search);
  // const token = query.get("token") || undefined;
  const [params, setParams] = useState({
    firstName: "",
    lastName: "",
    password: "",
    lang: language.toLowerCase(), // Use actual selected language
    buildingIndustryRole: "Others",
    areaOfActivity: "abc",
    fcmId: "rewszsdfswfw",
    token,
    username: "",
    kjupp: isKjuupPlus ? 1 : 0,
    isKjuupPlus: isKjuupPlus
  });
  const [viewPassword, setViewPassword] = useState(false);
  const [roleSelected, setRoleSelected] = useState(false);
  const [showRoles, SetShowRoles] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    buildingIndustryRole: "",
    areaOfActivity: "",
    fcmId: "",
    username: "",
    kjupp: isKjuupPlus ? 1 : 0,
    isKjuupPlus: isKjuupPlus
  });
  const position = BranchPosition;
  const [isInvalid, setIsInvalid] = useState(false);
  const [invalidMsg, setInvalidMsg] = useState("");
  const setParam = (name, value) => {
    setParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    setErrors((prev) => {
      return {
        ...prev,
        [name]: "",
      };
    });
  };
  useEffect(() => {
    if (!branchData)
      setParams({ ...params, token: token, isKjuupPlus: isKjuupPlus, kjupp: isKjuupPlus ? 1 : 0 })
    else {
      if (branchData.deptLocation && branchData.deptLocation != "null") {
        setParams({ ...params, token: token, isKjuupPlus: isKjuupPlus, kjupp: isKjuupPlus ? 1 : 0, deptLocation: branchData.deptLocation, isImportCompany: (branchData.isImportCompany == "1" || branchData.isImportCompany == 1) ? true : false })
      }
      else {
        setParams({ ...params, token: token, isKjuupPlus: isKjuupPlus, kjupp: isKjuupPlus ? 1 : 0, isImportCompany: (branchData.isImportCompany == "1" || branchData.isImportCompany == 1) ? true : false })
      }
    }
  }, [token, isKjuupPlus, branchData])

  useEffect(() => {
    const urlToken = new URLSearchParams(window.location.search).get("token");
    if (urlToken) {
      setToken(urlToken);
      return;
    }
    window.branch.init('key_live_oo9jqKxBpFc8WHQIPwZikihiCCd4oaEQ', function (err, data) {
    });
    window.branch.data(function (err, data) {
      setToken(data?.data_parsed?.registraTionToken)
      setIsKjuupPlus((data?.data_parsed?.isKjuupPlus == "true" || data?.data_parsed?.isKjuupPlus == true) ? true : false)
      setBranchData(data.data_parsed)
      console.log('--------------->branch data', data.data_parsed);
    });
    window.branch.first(function (err, data) {

    });
  }, [])

  useEffect(() => {
    var userLang = navigator.language || navigator.userLanguage;
    let registerLang = localStorage.getItem("regiLang");
    let storedLang = localStorage.getItem("language");
    
    // Check if stored language is supported (all 22 languages)
    if (storedLang && isLanguageSupported(storedLang)) {
      // Use stored language preference
      setIsGerm(storedLang === 'de');
      setLanguage(storedLang.toUpperCase());
    } else if (registerLang) {
      setIsGerm(registerLang == 2 ? true : false);
      setLanguage(registerLang == 2 ? "DE" : "EN");
    } else {
      if (userLang === "de") {
        localStorage.setItem("switch", "2");
        localStorage.setItem("language", "de");
        setIsGerm(true);
        setLanguage("DE");
      } else {
        localStorage.setItem("switch", "1");
        localStorage.setItem("language", "en");
        setIsGerm(false);
        setLanguage("EN");
      }
    }
  }, []);

  // Sync params.lang with language state when language changes
  useEffect(() => {
    setParams(prev => ({ ...prev, lang: language.toLowerCase() }));
  }, [language]);

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    //Role
    if (!params.buildingIndustryRole) {
      formIsValid = false;
      errors["buildingIndustryRole"] = t("invalid_fiels");
    }
    //Firstname
    if (!params.firstName) {
      formIsValid = false;
      errors["firstName"] = t("invalid_fiels");
    }
    if (!params.lastName) {
      formIsValid = false;
      errors["lastName"] = t("invalid_fiels");
    }
    if (!params.email) {
      formIsValid = false;
      errors["email"] = t("invalid_fiels");
    }
    if (!meetsPasswordRule(params.password, PASSWORD_MIN_LENGTH)) {
      formIsValid = false;
      errors["password"] = t("pass_error");
    }
    setErrors(errors);
    return formIsValid;
  };
  const handleValidationx = () => {
    let errors = {};
    let formIsValid = true;
    //Role
    if (!params.buildingIndustryRole) {
      formIsValid = false;
      errors["buildingIndustryRole"] = t("invalid_fiels");
    }
    //Firstname
    if (!params.firstName) {
      formIsValid = false;
      errors["firstName"] = t("invalid_fiels");
    }
    if (!params.lastName) {
      formIsValid = false;
      errors["lastName"] = t("invalid_fiels");
    }
    if (!params.username) {
      formIsValid = false;
      errors["username"] = t("invalid_fiels");
    }
    if (!params.password) {
      formIsValid = false;
      errors["password"] = t("invalid_fiels");
    }
    setErrors(errors);
    return formIsValid;
  };
  const history = useHistory();

  const register = async () => {
    if ((!isKjuupPlus && !params.isImportCompany)) {
      setLoading(true);
      setIsInvalid(false);
      if (handleValidation()) {
        try {
          var userLang = language.toLowerCase();
          params.lang = userLang;
          // Get firebase token and device ID from localStorage
          const tokenx = localStorage.getItem("firebaseToken");
          const deviceId = localStorage.getItem("uniqueDeviceId");
          // Add them to params
          const registerParams = {
            ...params,
            fcmId: tokenx || params.fcmId,
            deviceId: deviceId,
            captchaToken: captchaToken || undefined,
            kjuupIo: kjuupIo || undefined,
          };
          const data = await $crud.post("/auth/register", registerParams, { notify: false });
          console.log("data=>", data);
          if (!data.status) {
            setInvalidMsg(data.message);
            setIsInvalid(true);
          } else {
            try {
              sessionStorage.setItem("kjuupVerifyEmail", params.email || "");
            } catch (e) {}
            history.push({
              pathname: "/",
              state: { verifyEmailPending: true, registeredEmail: params.email },
            });
          }
        } catch (e) {
          console.log("data=>", e);
          setInvalidMsg(e.message);
          setIsInvalid(true);
        }
      }
      setLoading(false);
    }
    else {
      if (handleValidationx()) {
        // Get firebase token and device ID from localStorage
        const tokenx = localStorage.getItem("firebaseToken");
        const deviceId = localStorage.getItem("uniqueDeviceId");
        // Add to state for SecurityPIN
        history.push({
          pathname: "/security-pin",
          state: {
            ...params,
            fcmId: tokenx || params.fcmId,
            deviceId: deviceId,
            isRegister: true
          }
        });
      }
      // history.push("/security-pin");
    }
  };

  const handleCaptchaChange = ({ enabled, token }) => {
    setCaptchaEnabled(Boolean(enabled));
    setCaptchaToken(token || "");
  };

  const changeRole = (roles) => {
    setRoleSelected(false);
    const selectedRoles = roles.join(",");
    setParam("buildingIndustryRole", selectedRoles);
  };
  const handleChangeLanguage = (code) => {
    SetShowRoles(false);
    const langLower = String(code || "en").toLowerCase();
    const germanFamily = isGermanFamily(langLower);

    // Set switch for backward compatibility
    localStorage.setItem("switch", germanFamily ? "2" : "1");
    // Set new language key for multi-language support
    localStorage.setItem("language", langLower);
    localStorage.setItem("regiLang", germanFamily ? "2" : "1");

    setIsGerm(germanFamily);
    setLanguage(langLower.toUpperCase());
    if (setContextLanguage) setContextLanguage(langLower);
  };

  const plusForm = !!(isKjuupPlus || params.isImportCompany);
  // Register stays off until the password meets the rule (on top of the captcha gate), as on mobile.
  const passwordOk = meetsPasswordRule(params.password, plusForm ? PLUS_PASSWORD_MIN_LENGTH : PASSWORD_MIN_LENGTH);
  const captchaBlocked = captchaEnabled && !captchaToken && !plusForm;
  const site = isKjuupPlus ? "https://kjuup-plus.de" : "https://kjuup.de";

  // Kjuup Pro · Registration (mobile RegisterPro, built on the Sign in pattern): back chevron (none
  // from an invite link), title over the subline, the labelled fields with their inline validation,
  // the captcha card, then Register, the legal links and the hardware note.
  return (
    <AuthFrame testId="registerPro" pkg={kjuupIo ? "io" : undefined}>
      <AuthHead
        onBack={token ? null : () => history.push("/")}
        backLabel={t("sign_in")}
        logo={process.env.PUBLIC_URL + (isKjuupPlus ? "/assets/img/KjuupPlus.png" : "/assets/img/KJUUP-Schrift-Icon.png")}
        language={{ code: language.toLowerCase(), onChange: handleChangeLanguage, label: t("language") }}
      />

      <AuthTitle
        title={plusForm ? t("register_plus") : kjuupIo ? t("pro_auth_register_kjuup_io_title") : t("pro_auth_create_account")}
        sub={plusForm ? t("pro_auth_register_plus_sub") : kjuupIo ? t("pro_auth_register_kjuup_io_sub") : t("pro_auth_register_sub")}
      />

      {isInvalid && invalidMsg ? <AuthNotice tone="err" icon="error" text={invalidMsg} /> : null}

      <form
        className="kj-auth__fields"
        id="registerForm"
        noValidate
        onSubmit={(e) => { e.preventDefault(); register(); }}
      >
        <AuthInput
          id="registerFirstName"
          aria-label={t("first_name")}
          placeholder={t("first_name")}
          value={params.firstName}
          onChange={(e) => setParam("firstName", e.target.value)}
          error={!!errors.firstName}
          message={errors.firstName}
          type="text"
          autoComplete="given-name"
        />
        <AuthInput
          id="registerLastName"
          aria-label={t("last_name")}
          placeholder={t("last_name")}
          value={params.lastName}
          onChange={(e) => setParam("lastName", e.target.value)}
          error={!!errors.lastName}
          message={errors.lastName}
          type="text"
          autoComplete="family-name"
        />
        {!plusForm ? (
          <AuthInput
            id="registerEmail"
            aria-label={t("email")}
            value={params.email || ""}
            onChange={(e) => setParam("email", e.target.value)}
            placeholder={t("email")}
            error={!!errors.email}
            message={errors.email}
            type="email"
            autoComplete="email"
            autoCapitalize="none"
            spellCheck={false}
          />
        ) : (
          <AuthInput
            id="registerUsername"
            aria-label={String(t("username") || "").replace(/\s*\*+$/, "")}
            placeholder={String(t("username") || "").replace(/\s*\*+$/, "")}
            value={params.username}
            onChange={(e) => {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (emailRegex.test(e.target.value)) {
                setErrors({ ...errors, username: strings.prevent_email });
                e.preventDefault();
              } else {
                setErrors({ ...errors, username: null });
                setParam("username", e.target.value);
              }
            }}
            error={!!errors.username}
            message={errors.username}
            type="text"
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
          />
        )}
        <AuthInput
          id="registerPassword"
          aria-label={t("password")}
          placeholder={t("password")}
          value={params.password}
          onChange={(e) => setParam("password", e.target.value)}
          error={!!errors.password}
          message={errors.password || String(t("pass_minimum") || "").replace(/^\*+\s*/, "")}
          type={viewPassword ? "text" : "password"}
          autoComplete="new-password"
          autoCapitalize="none"
          spellCheck={false}
          trailing={
            <AuthEye
              shown={viewPassword}
              onToggle={() => setViewPassword(!viewPassword)}
              showLabel={t("pro_auth_show_password")}
              hideLabel={t("pro_auth_hide_password")}
            />
          }
        />
      </form>

      {!plusForm && (
        // The widget stays mounted to report whether captcha is on at all; the card only appears once it is.
        <div className={captchaEnabled ? "kj-auth__captcha" : undefined}>
          <RegisterCaptcha
            language={language}
            onTokenChange={handleCaptchaChange}
          />
        </div>
      )}

      <AuthSpacer />

      <div className="kj-auth__bottom">
        <button
          type="submit"
          form="registerForm"
          disabled={loading || captchaBlocked || !passwordOk}
          aria-busy={loading}
          className="kj-btn kj-btn--primary kj-btn--lg kj-btn--block kj-auth__btn"
        >
          {loading ? <LoadingDots /> : t("register")}
        </button>

        <div className="kj-auth__legal">
          <p className="kj-auth__meta">
            {t("when_register_you_agree")}{" "}
            <a href={`${site}/nutzungsbedingungen`} target="_blank" rel="noopener noreferrer">
              {t("term_of_use")}
            </a>
            {". "}
            {t("in_our")}{" "}
            <a href={`${site}/datenrichtlinien`} target="_blank" rel="noopener noreferrer">
              {t("data_policy")}
            </a>{" "}
            {t("they_find_out")} {t("we_provide_store_data")}
          </p>
          <a
            className="kj-auth__link kj-auth__link--start"
            href={`${site}/impressum-agb`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("imprint_gtc")}
          </a>
          <div className="kj-auth__hardware kj-auth__meta">
            <div className="kj-auth__hardware-title">{t("hardware_requirements")}:</div>
            <div dangerouslySetInnerHTML={{ __html: t("hardware_requirements_list") }} />
          </div>
        </div>
      </div>
    </AuthFrame>
  );
}

export default Register;
